"use client";

import { useEffect } from "react";
import { useParams } from "next/navigation";
import { setCookieByName } from "@/lib/cookies";
import { NEXT_LOCALE_COOKIE, resolveLocale } from "@/lib/resolvedLocale";
import { supportedLanguages, type SupportedLanguage } from "@/lib/shared";

/**
 * Syncs `<html lang>` and `dir` from the active locale (params, then pathname).
 * Keeps `NEXT_LOCALE` cookie aligned with the URL so nested SPA routes without
 * `locale` in `useParams` still match the visible language.
 */
export function DocumentLocale() {
  const params = useParams();
  const raw = params.locale as string | undefined;
  const locale: SupportedLanguage = resolveLocale(raw);

  useEffect(() => {
    document.documentElement.lang = locale === "ar" ? "ar" : "en";
    document.documentElement.dir = locale === "ar" ? "rtl" : "ltr";
    const pathSeg = window.location.pathname.split("/").filter(Boolean)[0];
    const fromUrl =
      raw && supportedLanguages.includes(raw as SupportedLanguage)
        ? raw
        : pathSeg && supportedLanguages.includes(pathSeg as SupportedLanguage)
          ? pathSeg
          : null;
    if (fromUrl) {
      void setCookieByName(NEXT_LOCALE_COOKIE, fromUrl as SupportedLanguage);
    }
  }, [raw, locale]);

  return null;
}
